import {VaccineModel} from '../model/vaccine.model';

export function removeFlu(vaccinationsToRemoveFrom: VaccineModel[]): VaccineModel[] {

    const hasGR_HD = vaccinationsToRemoveFrom.some(v => v.abbreviation === "GR_HD");
    const hasGR = vaccinationsToRemoveFrom.some(v => v.abbreviation === "GR");

    if (hasGR_HD && hasGR) {
        return vaccinationsToRemoveFrom.filter(v => v.abbreviation !== "GR");
    }

    return vaccinationsToRemoveFrom;
}
